import React, { useState, useEffect } from "react";
import TransparentButton from "../TransparentButton/TransparentButton";

function Alert({
  variant,
  message,
  dismissible,
  timeout,
  onClose,
  position,
  type,
}) {
  const [show, setShow] = useState(true);

  useEffect(() => {
    let timer;

    if (type !== "button") {
      if (timeout) {
        timer = setTimeout(() => {
          setShow(false);
          onClose();
        }, timeout - 500);
      }
    }

    return () => {
      clearTimeout(timer);
    };
  }, [timeout, onClose]);

  const handleClose = () => {
    setShow(false);
    onClose();
  };

  const getPositionStyles = () => {
    switch (position) {
      case "left":
        return { left: "1rem", right: "auto", top: "1rem" };
      case "right":
        return { left: "auto", right: "1rem", top: "1rem" };
      case "middle":
        return {
          left: "50%",
          transform: "translateX(-50%)",
          right: "auto",
          top: "1rem",
        };
      default:
        return { top: "1rem", right: "1rem" };
    }
  };

  const styles = {
    position: "fixed",
    zIndex: 9999,
    backgroundColor: "#fff",
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.5)",
    borderRadius: "5px",
    padding: "20px 20px 5px 20px",
    textAlign: "center",
    cursor: "pointer",
    overflow: "hidden",
    ...getPositionStyles(),
  };

  const lineStyles = {
    height: "4px",
    width: "100%",
    backgroundColor: variant === "success" ? "#28a745" : "#dc3545",
    position: "absolute",
    bottom: "0px",
    left: "0px",
    overflow: "hidden",
    animation: show ? `slideLeftToRight  ${timeout / 1000}s ease-out` : "none",
  };

  const keyFrames = `@keyframes slideLeftToRight {
        0% {
          transform: translateX(-100%);
        }
        100% {
          transform: translateX(0);
        }
      }
    `;

  return (
    <div style={styles} id="alert-box" onClick={handleClose}>
      <style>{keyFrames}</style>
      <div
        className={`alert alert-${variant} ${show ? "show" : "fade"} ${
          dismissible ? "alert-dismissible" : ""
        }
        `}
        role="alert"
      >
        {message}
      </div>
      <div style={lineStyles}></div>
      {type === "button" && (
        <div
          style={{
            marginBottom: "7px",
            display: "flex",
            justifyContent: "end",
          }}
        >
          <TransparentButton
            bg={variant === "success" ? "#28a745" : "#dc3545"}
            propstyle={{ minWidth: "65px" }}
            color={"#ffffff"}
            className={"d-block"}
            onClick={handleClose}
            opacity={0.8}
          >
            Ok
          </TransparentButton>
        </div>
      )}
    </div>
  );
}

export default Alert;
